import { render } from "./SegmentItem.vue?vue&type=template&id=86290808&scoped=true"
import script from "./SegmentItem.vue?vue&type=script&lang=js"
export * from "./SegmentItem.vue?vue&type=script&lang=js"

import "./SegmentItem.vue?vue&type=style&index=0&id=86290808&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86290808"]])

export default __exports__